import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'

import { megaActivationApi } from '../../api/mega-card-activation.api'
import { RootState } from '..'

type InitialState = {
  uuid: string | null
  mobile_phone: string | null
  card_quantity: number | null
}

const initialState: InitialState = {
  uuid: null,
  mobile_phone: null,
  card_quantity: null
}

const megaCardActivationSlice = createSlice({
  name: 'megaCardActivationSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(PURGE, () => initialState)
      .addMatcher(megaActivationApi.endpoints.createActivation.matchFulfilled, (state, { payload, meta }) => {
        state.mobile_phone = meta?.arg?.originalArgs?.mobile_phone || null
        state.card_quantity = payload.data.card_quantity
      })
      .addMatcher(megaActivationApi.endpoints.cardActivation.matchFulfilled, (state, { payload }) => {
        state.uuid = payload.data.uuid
      })
  }
})

export const mobilePhoneSelector = (state: RootState) => state.megaCardActivationSlice.mobile_phone
export const uuidMegaCardActivationSelector = (state: RootState) => state.megaCardActivationSlice.uuid
export const cardQuantitySelector = (state: RootState) => state.megaCardActivationSlice.card_quantity

export default megaCardActivationSlice.reducer
